"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TableRow = exports.TableHeader = exports.TableCell = exports.TableBody = exports.Table = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _Text = _interopRequireDefault(require("./Text"));
var _styles = require("@sart/styles");
var _excluded = ["children", "style"],
  _excluded2 = ["children", "style", "textStyle"],
  _excluded3 = ["children", "style", "textStyle"],
  _excluded4 = ["children", "style"],
  _excluded5 = ["children", "customRender", "size", "style", "textStyle"];
var Table = exports.Table = function Table(_ref) {
  var children = _ref.children,
    style = _ref.style,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, (0, _extends2["default"])({
    style: [styles.table, style]
  }, rest), children);
};
var TableHeader = exports.TableHeader = function TableHeader(_ref2) {
  var children = _ref2.children,
    style = _ref2.style,
    textStyle = _ref2.textStyle,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.header, style]
  }, children);
};
var TableBody = exports.TableBody = function TableBody(_ref3) {
  var children = _ref3.children,
    style = _ref3.style,
    textStyle = _ref3.textStyle,
    rest = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.body, style]
  }, children);
};
var TableRow = exports.TableRow = function TableRow(_ref4) {
  var children = _ref4.children,
    style = _ref4.style,
    rest = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, rest, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.row, style]
  }, children));
};
var TableCell = exports.TableCell = function TableCell(_ref5) {
  var children = _ref5.children,
    customRender = _ref5.customRender,
    size = _ref5.size,
    style = _ref5.style,
    textStyle = _ref5.textStyle,
    rest = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, (0, _extends2["default"])({
    style: [styles.cell, styles[size], style]
  }, rest), customRender ? customRender : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.text, textStyle]
  }, children));
};
TableCell.defaultProps = {
  size: "medium"
};
Table.Header = TableHeader;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Cell = TableCell;
var _default = exports["default"] = Table;
var styles = _reactNative.StyleSheet.create({
  table: {},
  header: {
    // flexDirection: "row",
  },
  body: {},
  row: {
    flexDirection: "row"
  },
  cell: {
    flexWrap: 'nowrap',
    justifyContent: 'center',
    paddingVertical: 4,
    marginRight: 24
  },
  text: {
    lineHeight: 24,
    color: _styles.colors.focus
  },
  tiny: {
    flex: 24,
    minWidth: 24,
    marginRight: 8
  },
  small: {
    flex: 48,
    minWidth: 48,
    marginRight: 16
  },
  medium: {
    flex: 96,
    minWidth: 96,
    marginRight: 16
  },
  large: {
    flex: 144,
    minWidth: 144,
    marginRight: 24
  },
  xlarge: {
    flex: 168,
    minWidth: 168,
    marginRight: 24
  }
});